<template><ArticlePage page="privacy" :content="content" /></template>
<script>
import ArticlePage from '@/components/ArticlePage.vue';
import content from '@/documents/content/privacy.js';
export default { name: 'Privacy', components: { ArticlePage }, data: () => ({ content }) };
</script>
